
export const SCOPES = [
    'playlist-read-private',
    'playlist-read-collaborative',
];